



















































































































import { Component, Watch, Mixins } from "vue-property-decorator";
import {Debounce} from "vue-debounce-decorator";

import CatalogMixin from '../../mixins/CatalogMixin';

import { RepositoryFabric } from "@api/repositories/RepositoryFabric";
import { UserRepository } from "@api/repositories/UserRepository";

import { GeneralCatalogItem } from '@api/models/GeneralCatalogItem';
import { QueryParametersInterface } from "@api/repositories/interfaces/QueryParametersInterface";
import {PROFILE_FIELDS_BASIC, UserProfile} from "@api/models/UserProfile";
import { SelectableTag } from '@api/models/SelectableTag';

import ImageCard from "../PartnerCard.vue";
import TableSearch from "@share/common/table-search/TableSearch.vue";
import TagList from "@share/common/tag-list/TagList.vue";
import ControlWrapper from "@share/common/ControlWrapper.vue"
import Overlay from "@share/common/Overlay.vue";
import DarkModalWindow from "@service/components/modal/DarkModal.vue";
import { ArrayHelpers } from "@common/ArrayHelpers";
import vueUpdateArray from '@common/vueUpdateArray';
import AdminPanel from "@share/common/admin-panel/AdminPanel.vue";
import PartnerListFormStub from "@share/catalog/components/list/PartnerListFormStub.vue";
import { AsyncComponentFactory } from "vue/types/options";
import PlusIcon from "@share/common/PlusIcon.vue";
import { NoticeLevel } from "@service/components/toast/type/Enums";
import { Notice } from "@service/components/toast/type/Notice";
import { noticeActions } from "@service/store/notice/actions";

class Category { id: string; title: string; numElements: number; isCollapsed: boolean }

// @ts-ignore
//https://github.com/vuejs/vue/issues/10252 bug in type defenition
const PartnerCreate: AsyncComponentFactory = () => {
    return {
        component: import( /* webpackChunkName: "partnerCreate" */ '@share/catalog/components/admin/PartnerCreate.vue'),
        delay: 120,
        loading: PartnerListFormStub
    }
}

@Component({
    components: {
        AdminPanel, ImageCard, Overlay, TableSearch, TagList, ControlWrapper, DarkModalWindow,
        PartnerCreate, PlusIcon
    }
})
export default class PartnerList extends Mixins(CatalogMixin) {

    userRepository: UserRepository;

    isLoading = false;
    rootItems: GeneralCatalogItem[] = [];
    secondLevelItems: GeneralCatalogItem[] = [];
    profiles: Record<string, UserProfile[]> = {};
    updateTimerId: number | null = null;
    searchStr = '';
    searchableFields = ['title', 'description'];
    isAllFilterShowed = false;
    selectedTagIds: string[] = [];
    tagsForModal: SelectableTag[] = [];
    numCardsInRow = 1;
    categories: Category[] = [];

    showPartnerCreate = false;

    itemsIdsForDelete: string[] = [];

    // Vue hooks
    created() {
        this.userRepository = this.$repositories.get(RepositoryFabric.USER);
    }

    async mounted() {
        this.numCardsInRow = this.cardsInRow();
        await this.init();
        window.addEventListener('resize', this.resizeHandler);
        this.updateTimerId = window.setInterval(this.fetch, 60000);
    }

    async fetch() {
        this.isLoading = true;

        const or = [
                {
                    eventId: {
                        $eq: this.$store.getters['events/selectedEvent']?.id
                    }
                },
                {
                    eventId: {
                        $exists: false
                    }
                }
            ];
        let condition: Record<string, any> = {
                take: -1,
                include: ['id', 'title'],
                order: [{ column: "orderIndex", direction: "asc" }],
                where: {
                    parentId: null,
                    groupIds: {
                        $containsAnyOrNullOrEmpty: this.$store.state.session.profile?.groupIds || []
                    },
                    $or: or
                }
            };

        const items = await this.fetchItems(condition) as any as GeneralCatalogItem[];

        vueUpdateArray(this.rootItems, items);

        condition = {
            take: -1,
            include: ['id', 'title', 'iconFileId', 'imageFileId', 'parentId', 'description', 'userProfileIds',
                'orderIndex', 'isOnline', 'userProfileIds', 'tagsIds', 'onlineParams', 'isMain', 'eventId'],
            where: {
                parentId: { $exists: true },
                groupIds: {
                    $containsAnyOrNullOrEmpty: this.$store.state.session.profile?.groupIds || []
                },
                $or: or
            }
        };

        if (this.isFilterSet) {
            condition.where.tagsIds = {};
            condition.where.tagsIds.$containsAny = this.tags.filter(item => item.isSelected).map(item => item.tag.id);
        }

        if (this.searchStr) {
            const parts: string[] = this.searchStr.split(' ');
            const words: string[] = parts.map((part: string) => `(?i).*${part}.*`);

            condition.where.$search = [
                this.searchableFields,
                words
            ]
        }

        const secondLevelItems = await this.fetchItems(condition) as any as GeneralCatalogItem[];

        const userProfilesMap: Record<string, boolean> = {};
        secondLevelItems.forEach(catalogItem => {
            if (Object.prototype.hasOwnProperty.call(catalogItem, 'userProfileIds') && catalogItem.userProfileIds) {
                catalogItem.userProfileIds.forEach((userProfileId: string) => {
                    userProfilesMap[userProfileId as string] = true;
                })
            }
        });

        const userIds: number[] = [];
        const userProfileIds: Array<string> = Object.keys(userProfilesMap);
        let mappedUserProfiles: Record<string, UserProfile> = {};
        if (userProfileIds.length) {
            const fetchedProfiles = await this.$repositories.get<UserRepository>(RepositoryFabric.USER).profiles({
                take: -1,
                where: {
                    id: {
                        $in: userProfileIds
                    }
                },
                include: PROFILE_FIELDS_BASIC
            })
            mappedUserProfiles = ArrayHelpers.keyBy(fetchedProfiles, 'id');
            fetchedProfiles.forEach((profile: UserProfile) => {
                userIds.push(profile.userId as number)
            });
        }

        const counter = this.$store.getters['onlineUsers/counter']('general');

        const onlineUsers: number[] = counter !== undefined ? ArrayHelpers.intersect(userIds, counter.userIds) : [];

        secondLevelItems.forEach((item) => {
            const itemProfiles: UserProfile[] = [];

            if (Object.prototype.hasOwnProperty.call(item, 'userProfileIds') && item.userProfileIds) {
                item.userProfileIds.forEach((profileId: string) => {
                    if (mappedUserProfiles[profileId] !== undefined) {
                        const userId = mappedUserProfiles[profileId].userId as number;
                        if (onlineUsers.includes(userId)) {
                            mappedUserProfiles[profileId].isOnline = true;
                        }
                        itemProfiles.push(mappedUserProfiles[profileId]);
                    }
                })
            }
            this.profiles[item.id] = itemProfiles;
        });

        vueUpdateArray(this.secondLevelItems, secondLevelItems);

        if (!this.isGeneralCatalog) {
            this.updateCategories();
        }

        this.isLoading = false;
    }

    updateCategories() {
        this.rootItems.forEach(item => {
            const category = this.categories.filter(category => category.id === item.id)?.[0];
            if (category) {
                category.title = item.title;
                category.numElements = this.childItems(item.id).length;
            } else {
                this.categories.push({
                    id: item.id,
                    title: item.title,
                    numElements: this.childItems(item.id).length,
                    isCollapsed: true
                });
            }
        })
    }

    itemsToShowInCategory(category: Category) {
        const items = this.childItems(category.id);
        if (category.isCollapsed) {
            return items.slice(0, this.numCardsInRow);
        }
        return items;
    }

    cardsInRow() {
        const container = document.body as HTMLElement,
            cardWidth = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--min-card-width')),
            containerPadding = getComputedStyle(document.documentElement).getPropertyValue('--container-padding'),
            innerWidth = container.clientWidth - 2 * parseInt(containerPadding);

        return Math.min(4, Math.floor(innerWidth / cardWidth));
    }

    async init() {
        this.loadFromLocalStorage()
        await this.fetch();

        if (this.itemId) {
            // this.openModal();
            this.resizeHandler();
        }
    }

    // API calls
    private async fetchItems(query: QueryParametersInterface) {
        return await this.objectRepository.query(this.schemaId, query);
    }

    activated() {
        document.body.classList.add("fixed-body")
    }

    deactivated() {
        document.body.classList.remove("fixed-body")
    }

    async removePartner(id: string) {
        try {
            this.itemsIdsForDelete.push(id);

            await this.objectRepository.delete(this.schemaId, [id])

            vueUpdateArray(this.secondLevelItems, this.secondLevelItems.filter(item => item.id !== id));
        }
        catch(e) {
            this.$store.dispatch('reportException', e, { root: true });
            const notice: Notice = {
                text: this.$t("exhibition.partnerDeleteFailed").toString(),
                level: NoticeLevel.danger
            }

            this.$store.dispatch(noticeActions.submitNotice, notice);
        }
        finally {
            this.itemsIdsForDelete = this.itemsIdsForDelete.filter(itemIdForDelete => itemIdForDelete !== id)
        }
    }

    // Helpers
    get childItems() {
        return (itemId: string) => {

            const items = this.secondLevelItems.filter(item => item.parentId === itemId);
            items.sort((a, b) => {
                if (a.orderIndex != null && b.orderIndex != null) {
                    return a.orderIndex - b.orderIndex;
                } else if (a.orderIndex != null) {
                    return -1;
                } else if (b.orderIndex != null) {
                    return 1
                }
                return a.title < b.title ? -1 : 0;
            });

            return items;
        }
    }

    get childItemsForContinuous() {

        let childs: GeneralCatalogItem[] = [];

        this.rootItems.forEach(rootItem => {
            const items = this.secondLevelItems.filter(item => item.parentId === rootItem.id);
            items.sort((a, b) => {
                if (a.orderIndex != null && b.orderIndex != null) {
                    return a.orderIndex - b.orderIndex;
                } else if (a.orderIndex != null) {
                    return -1;
                } else if (b.orderIndex != null) {
                    return 1
                }
                return a.title < b.title ? -1 : 0;
            });
            childs = childs.concat(items);
        })

        return childs;
    }

    getRootItem(id: string) {
        return this.rootItemsById[id];
    }

    get rootItemsById() {
        return ArrayHelpers.keyBy(this.rootItems, "id");
    }

    get lsKey() {
        return this.$store.state.session.backend + this.$store.getters.userId + '_catalog-filter_' + this.schemaId;
    }

    @Watch('itemId')
    private onObjectIdChange() {
        this.resizeHandler();
    }

    @Watch('schemaId')
    private onSchemaIdChange() {
        this.rootItems = [];
        this.secondLevelItems = [];
        this.categories = [];
        this.getTags();
        this.init();
    }

    showCardInfo(item: GeneralCatalogItem | null) {
        //preventing click when element on removing
        if (item && !this.itemsIdsForDelete.includes(item.id)) {
            this.$router.push({
                name: 'Partner',
                params: {
                    ...this.$route.params,
                    id: item.id
                }
            });
        }
    }

    //@todo centralized resize & modal open handler
    resizeHandler() {
        this.numCardsInRow = this.cardsInRow();
    }

    reload() {
        this.fetch();
        this.$nextTick(() => {
            (this.$refs['list'] as HTMLElement).scrollTo({
                top: 0
            });
        })
    }

    @Debounce(500)
    onSearchInput() {
        this.reload();
    }

    onSelectTag(eventItem: SelectableTag) {
        this.switchSelection(this.tags, eventItem);
        this.saveToLocalStorage();
        this.reload();
    }

    // ищет в массиве tags элемент и переключает ему isSelected на противоположное значение для syncItem.isSelected
    switchSelection(tags: SelectableTag[], syncItem: SelectableTag) {
        tags.forEach(item => {
            if (item.tag.id === syncItem.tag.id) {
                item.isSelected = !syncItem.isSelected;
            }
        });
    }

    get isFilterSet() {
        return this.tags.some(item => item.isSelected);
    }

    showFiltersModal() {
        this.selectedTagIds = [];
        this.tagsForModal = this.tags.map(item => {
            if (item.isSelected) {
                this.selectedTagIds.push(item.tag.id);
            }
            return { tag: item.tag, isSelected: item.isSelected }
        });
        this.isAllFilterShowed = true;
    }

    closeFiltersModal() {
        this.isAllFilterShowed = false;
    }

    closePartnerCreate() {
        this.showPartnerCreate = false;
    }

    openPartnerCreate() {
        this.showPartnerCreate = true;
    }

    clearInput() {
        this.searchStr = "";
        this.onSearchInput();
    }

    applyFilters() {
        this.tags.forEach(item => {
            if (this.selectedTagIds.indexOf(item.tag.id) >= 0) {
                item.isSelected = true;
            } else {
                item.isSelected = false;
            }
        });
        this.isAllFilterShowed = false;
        this.selectedTagIds = [];
        this.saveToLocalStorage();
        this.reload();
    }

    resetFilters() {
        this.tags.forEach(item => item.isSelected = false);
        this.saveToLocalStorage();
        this.isAllFilterShowed = false;
        this.reload();
    }

    accumulateTag(eventItem: SelectableTag) {
        if (!eventItem.isSelected) {
            this.selectedTagIds.push(eventItem.tag.id);
        } else {
            this.selectedTagIds = this.selectedTagIds.filter(id => id !== eventItem.tag.id);
        }
        this.switchSelection(this.tagsForModal, eventItem);
    }

    saveToLocalStorage() {
        localStorage.setItem(this.lsKey, JSON.stringify(this.tags.filter(item => item.isSelected).map(item => item.tag.id)));
    }

    loadFromLocalStorage() {
        const ids = localStorage.getItem(this.lsKey);
        if (!ids) {
            return;
        }

        this.tags.forEach(item => {
            if (ids.indexOf(item.tag.id) >= 0) {
                item.isSelected = true;
            }
        });
    }

    destroyed() {
        this.updateTimerId && clearInterval(this.updateTimerId);
        window.removeEventListener('resize', this.resizeHandler);
    }

    get isOnEditing() {
        return this.$store.state.isOnEditing;
    }
}
